import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { fetchData, formatDate, formatNumber, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import { KTIcon, reInitMenu } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useNavigate } from 'react-router-dom'



const ViewAmbassadors: FC = () => {
  let t = Tr()
  const { menuId } = useMenuIdPermissions()
  const [userReferralList, setUseruserReferralList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any
  const [sortColumn, setSortColumn] = useState('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc')
  const [apiTerm, setApiTerm] = useState('')
  const navigate = useNavigate()

  //   referral and review list api call
  const userReferralListApiCall = async () => {
    var param: any = {
      limit: limit,
      offset: offset,
      search: apiTerm,
      sort: sortDirection,
      sortBy: sortColumn,
    }

    var res = await fetchData('admin/viewuserwisereferral ', param)

    if (res.status == '200') {
      var data = res.data

      setUseruserReferralList(data.data)
      setTotalRecords(data.totalRecords)

    } else {
      toasterrormsg(res.message)
    }
  }

  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    const escapedTerm = text.replace(/'/g, "''")
    setApiTerm(escapedTerm)
  }

  const handleSort = (column: any, sortDirection: 'asc' | 'desc') => {
    setSortColumn(column.sortField)
    setSortDirection(sortDirection)
  }
  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Ambassador')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>

      </div>
    )
  }

  // Define your DataTable columns
  const column = useMemo(
    () => [

      {
        name: t('Ambassador'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.fullName && row.fullName != "" ? row.fullName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'fullName',
      },
      {
        name: t('Date Signed Up'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.created && row.verifiedDate != "" ? formatDate(row.created, "MM-DD-YYYY") : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'created',
      },
      {
        name: t('Referral Code'),
        cell: (row: any) => {
          return (
            <div className='my-3'>
              <div className='fw-bold fs-5'>{row.referralCode && row.referralCode != "" ? row.referralCode : "-"}</div>
            </div>
          );
        },
        sortable: true,
        width: '200px',
        sortField: 'propertyStatus',
      },

      {
        name: t('Number of referrals'),
        cell: (row: any) => (
          <div className='my-3 '>
            <div onClick={(e) => {
              navigate(getEncryptedRoute("../viewambassadorsreferrals", { menuId: menuId, referralCode: row.referralCode }))
            }} className='fw-bold fs-5 text-primary text-decoration-underline cursor-pointer' >{row.numberOfReferrals && row.numberOfReferrals != "" ? row.numberOfReferrals : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'numberOfReferrals',
      },
      {
        name: t('Number of accepted referrals'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.numberOfAcceptedReferrals && row.numberOfAcceptedReferrals != "" ? row.numberOfAcceptedReferrals : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'numberOfAcceptedReferrals',
      },
      {
        name: t('Earnings'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.amount && row.amount != "" ? formatNumber(row.amount) : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'amount',
      },
      {
        name: t('Region'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.regionName && row.regionName != "" ? row.regionName : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'regionName',
      },
      {
        name: t('Phone Number'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.mobileNumber && row.mobileNumber != "" ? row.mobileNumber : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'mobileNumber',
      },
      {
        name: t('Email'),
        cell: (row: any) => (
          <div className="my-3">
            <div className="fw-bold fs-5">
              {row.email && row.email !== "" ? row.email : "-"}
            </div>
          </div>
        ),
        sortable: false,
        width: "250px",
        sortField: "email",
      },
      {
        name: t('Age'),
        cell: (row: any) => (
          <div className="my-3">
            <div className="fw-bold fs-5">
              {row.age && row.age !== "" ? row.age : "-"}
            </div>

          </div>
        ),
        sortable: false,
        width: "250px",
        sortField: "age",
      },

      {
        name: t('Gender'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.gender && row.gender != "" ? row.gender : "-"}</div>
          </div>
        ),
        sortable: true,
        width: '200px',
        sortField: 'gender',
      },


    ],
    [t]
  )
  useEffect(() => {
    userReferralListApiCall()
    document.title = 'Insayr | View Review Category Wise'
  }, [limit, offset, sortColumn, sortDirection, searchTerm]) // Trigger on pagination changes


  const handlePageChange = (newPage: number) => {
    const totalPages = Math.ceil(totalRecords / limit)
    if (newPage === 1) {
      setOffset(0)
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit)
    } else {
      setOffset((newPage - 1) * limit)
    }
  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }

  return (
    <>
      <ToastContainer />

      <DataTable
        columns={column}
        data={userReferralList}
        pagination
        paginationServer={true}
        onChangePage={handlePageChange}
        paginationTotalRows={totalRecords}
        paginationPerPage={limit}
        onChangeRowsPerPage={handleRowsPerPageChange}
        paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
        subHeader={true}
        subHeaderComponent={<CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />}
        onSort={handleSort}
        paginationComponentOptions={{
          rowsPerPageText: t('Rows Per Page'),
        }}
        sortServer
      />


    </>
  )
}

export { ViewAmbassadors }
